<template>
    <new-modal
        size="xl"
        :title="'Delete Archived Classroom?'"
        ref="delete_archive_classroom_modal"
    >
        <template #trigger>
            <span class="link block p-4 !text-red-500 hover:text-red-700">
                Delete Classroom
            </span>
        </template>
        <template #content>
            <div class="flex flex-col gap-4">
                <div class="mb-8 flex flex-col gap-4">
                    <p>
                        Do you want to permanently delete your archived
                        classroom
                    </p>
                </div>
                <div class="flex justify-end">
                    <div class="btn btn-transparent" @click="cancel">
                        Cancel
                    </div>
                    <div
                        class="btn btn-danger"
                        @click="deleteArchivedClassroom"
                    >
                        Permanently Delete Classroom
                    </div>
                </div>
            </div>
        </template>
    </new-modal>
</template>
<script>
import NewModal from "@/Components/NewModal";

export default {
    name: "GroupDeleteArchivedClassroomModal",
    emits: ["close-modal"],
    components: {
        NewModal,
    },
    props: {
        archivedClassroomId: {
            type: Number,
            default: null,
        },
    },
    methods: {
        deleteArchivedClassroom() {
            this.$inertia.get(
                route("group.classroom.archived.delete", {
                    archived_classroom: this.archivedClassroomId,
                })
            );
        },
        cancel() {
            this.$refs.delete_archive_classroom_modal.closeModal();
        },
    },
};
</script>
